import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            "&.MuiTableCell-root": {
                background: "#FFFFFF",
                fontFamily: theme.typography.subtitle2.fontFamily,
                fontSize: theme.typography.subtitle2.fontSize,
                "&.MuiButtonBase-root": {
                    color: theme.palette.text.primary,
                },
                fontWeight: theme.typography.subtitle2.fontWeight,
            },
        },
    }),
);
